// apps/web/src/components/tax/TaxManager.tsx
// Tax configuration + returns management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { TaxReturn } from '../../types/platform.js';

export function TaxManager() {
  return (
    <ManagerPage
      title="Tax"
      listPath="/api/v1/tax/returns"
      listKey="returns"
      className="tax-manager"
      renderItem={(raw) => {
        const t = raw as TaxReturn;
        return (
          <div className="manager-card" key={t.id}>
            <h3>Period {t.period}</h3>
            <p className="status-badge">{t.status}</p>
            <p>Filed {t.createdAt}</p>
            <div className="actions">
              <button className="btn btn-secondary">View</button>
              <button className="btn btn-primary">Submit Return</button>
            </div>
          </div>
        );
      }}
    />
  );
}